export const SET_USER_MANAGE_LIST = "setUserManageList";

export const setUserManageList = (userManageList) => ({type: SET_USER_MANAGE_LIST,userManageList})